import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from '../util/withRouter';
import { connect } from 'react-redux';
import _ from 'lodash';

import { windowLocation } from '../util/url';

export default function (ComposedComponent) {
  class RequirePortfolioAccess extends Component {
    static contextTypes = {
      router: PropTypes.object,
    };

    redirect(to) {
      windowLocation() && windowLocation().replace(to + windowLocation().search);
    }

    render() {
      const { user, routeParams, route, portfolios } = this.props;

      if (this.props.isLoading) {
        return <div></div>;
      }

      if (!user.permissions) {
        this.redirect('/');
        return null;
      }

      const fullAccess = user.permissions.managePortfolios;
      const viewAccess = user.permissions.managePortfoliosViewOnly;

      if (routeParams.id) {
        const granularAccess = user.permissions && user.permissions.portfolios &&  _.find(user.permissions.portfolios, s => s.portfolioId === routeParams.id);

        const access =
          fullAccess && { view: true, edit: true, delete: true } ||
          viewAccess && { view: true } ||
          granularAccess || {};

        if (route.path.indexOf('portfolios') > -1 && !access.view && !access.edit && !access.delete) {
          this.redirect('/portfolios');
          return null;
        } else if (route.path.indexOf('portfolio/') > -1 && !access.edit) {
          this.redirect('/portfolios');
          return null;
        }
      } else {
        if (route.path.indexOf('portfolios') > -1 && !(user.permissions.portfolios && user.permissions.portfolios.length) && !(fullAccess || viewAccess)) {
          this.redirect('/no-portfolios');
          return null;
        }
        if (route.path.indexOf('portfolio/') > -1 && !user.permissions.createPortfolios) {
          this.redirect('/portfolios');
          return null;
        }
      }

      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      user: state.auth.user,
      portfolios: state.portfolio.portfolios,
      isLoading: state.auth.isLoading,
    };
  }

  return withRouter(connect(mapStateToProps)(RequirePortfolioAccess));
}
